// extracted by mini-css-extract-plugin
module.exports = {"root":"Notification_root__D5iRy","title":"Notification_title__LtV3W","closeButton":"Notification_closeButton__tDSGM"};